/* eslint-disable no-param-reassign */
import {
    createSlice,
} from '@reduxjs/toolkit';


// Initial state
const initialState: any = {
    title: '',
    count: null,
    icon: null,
};

export const PageTitleSlice = createSlice({
    name: 'page-title',
    initialState,
    reducers: {

        /**
         * Function to change page title
         * @param state
         * @param action
         */
        setPageTitle: (state, action) => {
            if (typeof action.payload === 'string') {
                state.title = action.payload;
                state.count = null;
                state.icon = null;
            } else {
                state.title = action.payload.title;
                state.count = action.payload.count;
                state.icon = action.payload.icon;
            }
        },

    },

});

// Export the reducer
export const { setPageTitle } = PageTitleSlice.actions;

export default PageTitleSlice.reducer;
